import AdvancedProgressBar from '@/components/advancedProgressBar';
import { cn } from '@/utils/cn';

export function RankingPercentage({
  hasRanking,
  percentage,
  className,
}: {
  hasRanking: boolean;
  percentage: number;
  className?: string;
}) {
  const text = hasRanking ? 'Ranking' : 'Unranked';
  const percentageValueDisplayed = hasRanking ? percentage : 0;
  return (
    <div className={cn(className)}>
      <div className="mb-1 flex items-center justify-between">
        <p className="text-xs">{text}</p>
        <p className="font-bold text-sm">{percentageValueDisplayed}%</p>
      </div>
      <AdvancedProgressBar progress={percentageValueDisplayed} />
    </div>
  );
}
